import TablaAbmCarousel from "./TablaAbmCarousel";
import MainCarousel from "../paginasInicio/MainCarousel";

const AbmCarousel = () => (
  <div className="divoverflow">
    <TablaAbmCarousel />
    <MainCarousel />
    <p className="m-2">* Las imagenes del banner estan ordenadas descendentemente por su fecha de creación</p>
  </div>
);

export default AbmCarousel;